// Styles for OffersDetailsCard go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';
import { mediaQuery } from '../../utils/styles';

export const StyledOffersDetailsCard = styled.div`
  .offerDetails-container {
    width: 100%;
    padding: ${toRem(48)} ${toRem(0)};
    @media ${mediaQuery.desktop} {
      display: flex;
      gap: ${toRem(168)};
    }

    @media ${mediaQuery.tabletMax} {
      padding: ${toRem(16)} ${toRem(0)};
      display: block;
    }
    @media ${mediaQuery.tabletOnly} {
      padding: ${toRem(16)} ${toRem(0)};
    }
    @media ${mediaQuery.mobileOnly} {
      padding: ${toRem(32)};
    }

    .content-wrapper {
      @media ${mediaQuery.desktop} {
        max-width: ${toRem(558)};
      }
      @media ${mediaQuery.tabletOnly} {
        max-width: ${toRem(704)};
      }
      .text-details {
        .t-font-s {
          margin-bottom: 0px !important;
        }
        .custom-styles {
          margin-bottom: 8px !important;
          @media ${mediaQuery.tabletMax} {
            font-size: ${toRem(35)};
          }
        }
      }
      .text-title {
        .t-font-s {
          margin-bottom: 0px !important;
        }
        .custom-styles {
          margin-bottom: 8px !important;
        }
        @media ${mediaQuery.tabletMax} {
          font-size: ${toRem(27)};
        }
      }

      .text-sub-details {
        .t-font-s {
          margin-bottom: 8px !important;
        }
        .custom-styles {
          margin-bottom: 8px !important;
        }
      }
      .link-wrapper {
        gap: 8px;
        font-size: ${toRem(12)};
        flex-wrap: wrap;
        .link-divider {
          border-left: ${toRem(1)} solid ${baseVariables.color.base10};
        }
        a {
          font-weight: 500;
          border-bottom: 1px solid ${baseVariables.color.base10};
          font-size: ${toRem(14)};
          line-height: ${toRem(16)};
          @media ${mediaQuery.mobileTablet} {
            font-size: ${toRem(16)};
          }
          @media ${mediaQuery.tabletMax} {
            font-size: ${toRem(16)};
          }
        }
      }
      .credit-card-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: ${toRem(8)};
        .logo-image {
          height: ${toRem(130)};
          margin-bottom: ${toRem(16)};
          object-fit: contain;
        }
      }

      .text-block div {
        color: ${theme.color['dark-gray-13']};
      }
      .text-block h2 {
        @media ${mediaQuery.mobileOnly} {
          font-size: ${toRem(25)};
        }
      }
    }
    .listItem-wrapper {
      @media ${mediaQuery.desktop} {
        flex: 1;
      }

      @media ${mediaQuery.tabletMax} {
        margin-top: ${toRem(32)};
      }

      @media ${mediaQuery.mobileOnly} {
        margin-top: ${toRem(32)};
      }
      .list-container {
        border-radius: ${toRem(14)};
        background-color: white;
        padding: ${toRem(32)};
      }
      .bullet-points {
        margin-bottom: ${toRem(16)};
        color: ${baseVariables.color.bvyBase30};
      }
      .bullet-points:last-child {
        margin-bottom: 0px;
      }
    }
  }
`;
